module.exports = __webpack_public_path__ + "img/add-arrival-table-icon.384e547d.svg";